var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingCircleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.435,
    height: 51.985,
    viewBox: "0 0 53.435 51.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.014,
    y1: 0.38,
    x2: 0.986,
    y2: 0.62,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7fbfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#79bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#6bb1d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#53a0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#3189c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.014,
    y1: 0.38,
    x2: 0.986,
    y2: 0.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.014,
    y1: 0.38,
    x2: 0.986,
    y2: 0.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -571.932,
    y1: -101.008,
    x2: -570.961,
    y2: -100.768,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -576.708,
    y1: -100.879,
    x2: -575.737,
    y2: -100.639,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -681.156,
    y1: -115.552,
    x2: -680.185,
    y2: -115.312,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -905.216,
    y1: -149.49,
    x2: -904.245,
    y2: -149.251,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(53.435) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 6.944,
    cy: 6.944,
    r: 6.944,
    transform: "translate(17.101)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 6.387,
    cy: 6.387,
    r: 6.387,
    transform: "translate(33.177 6.945)",
    opacity: 0.92,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 6.034,
    cy: 6.034,
    r: 6.034,
    transform: "translate(39.917 21.723)",
    opacity: 0.86,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 5.83,
    cy: 5.83,
    r: 5.83,
    transform: "translate(33.735 37.501)",
    opacity: 0.78,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 5.053,
    cy: 5.053,
    r: 5.053,
    transform: "translate(18.992 43.33)",
    opacity: 0.55,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 4.984,
    cy: 4.984,
    r: 4.984,
    transform: "translate(3.443 35.766)",
    opacity: 0.42,
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 4.213,
    cy: 4.213,
    r: 4.213,
    transform: "translate(0 20.351)",
    opacity: 0.26,
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 3.178,
    cy: 3.178,
    r: 3.178,
    transform: "translate(7.602 9.173)",
    opacity: 0.15,
    fill: "url(#linear-gradient-8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircleLogo);
export default __webpack_public_path__ + "static/media/loading-circle_logo.ffab5e84276b065831d5e1b3986f5b44.svg";
export { ForwardRef as ReactComponent };